import React from "react"
import {OverheadCameraDeviceOverviewContext} from "./context/OverheadCameraDeviceOverviewContext";
import CameraDeviceOverview from "./CameraDeviceOverview";

const OverheadCameraDeviceOverview = (props) => {
    return <CameraDeviceOverview {...props} deviceContext={OverheadCameraDeviceOverviewContext}/>;
}

export default OverheadCameraDeviceOverview



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/OverheadCameraDeviceOverview.js